import FileInputService from '@isceco/widget-library2/basic-elements/FileInput/FileInputService.js';

export class EformFileInputService extends FileInputService {

  constructor(url, hash = crypto.randomUUID(), refreshCaptchaFn = null) {
    super(url)
    this.formHash = hash // formHash is used to keep attachments together, though helping to rename files properly when multiple documents have the same name
    this.refreshCaptchaFn = refreshCaptchaFn
  }

  async upload(file) {
    // Generate a fresh captcha token right before every upload (tokens are single-use with a 5 min TTL)
    const captchaToken = this.refreshCaptchaFn ? await this.refreshCaptchaFn() : null

    const form = new FormData()
    form.append('fileName', file.name)
    form.append('file', file)
    form.append('formHash', this.formHash)

    const options = this.getOptions(form)

    if (captchaToken) {
      options.headers = options.headers || {}
      options.headers['X-Captcha-Token'] = captchaToken
    }

    return fetch(this.url, options)
  }

  resetHash(hash = crypto.randomUUID()) {
    this.formHash = hash
  }
}
